module.exports = __webpack_public_path__ + "img/card-budget.57082972.svg";